import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const businessPortfolioData = [
  {
    id: 1,
    img: "assets/images/services/services-thumb-08.png",
    title: "Automation industry management",
    desc: "Consectetur ipiscing elit tellus ullam corper mattis",
  },
  {
    id: 2,
    img: "assets/images/services/services-thumb-09.png",
    title: "Fuel & Gas management",
    desc: "Consectetur ipiscing elit tellus ullam corper mattis",
  },
  {
    id: 3,
    img: "assets/images/services/services-thumb-14.png",
    title: "Best innovations in metallurgy",
    desc: "Consectetur ipiscing elit tellus ullam corper mattis",
  },
  {
    id: 4,
    img: "assets/images/services/services-thumb-15.png",
    title: "Fuel & Gas management",
    desc: "Consectetur ipiscing elit tellus ullam corper mattis",
  },
  {
    id: 5,
    img: "assets/images/services/services-thumb-16.png",
    title: "Oil construction and gas production",
    desc: "Consectetur ipiscing elit tellus ullam corper mattis",
  },
  {
    id: 6,
    img: "assets/images/services/services-thumb-31.png",
    title: "State of the art for high control",
    desc: "Consectetur ipiscing elit tellus ullam corper mattis",
  },
  {
    id: 7,
    img: "assets/images/services/services-thumb-32.png",
    title: "Fuel & Gas management",
    desc: "Consectetur ipiscing elit tellus ullam corper mattis",
  },
  {
    id: 8,
    img: "assets/images/services/services-thumb-33.png",
    title: "Manufacturer of tin lead and lead",
    desc: "Consectetur ipiscing elit tellus ullam corper mattis",
  },
];

const BusinessPortfolio = () => {
  return (
    <>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">
                    Business Portfolio
                  </h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>Business Portfolio</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rs-services-area rs-services-three section-space has-theme-orange">
        <div className="container">
          <div className="row g-5 process-counts">
            {businessPortfolioData.map((item) => {
              return (
                <div key={item.id} className="col-xl-3 col-lg-4 col-md-6">
                  <div className="rs-services-wrapper">
                    <div className="rs-services-item">
                      <div className="rs-services-thumb">
                        {/* <Link to="/services-details"> */}
                        <Link to="#">
                          <img src={item.img} alt="imagee" />
                        </Link>
                      </div>
                      <div className="rs-services-content">
                        <h5 className="rs-services-title">
                          <Link to="#">{item.title}</Link>
                        </h5>
                        <p className="descrip">{item.desc}</p>
                        <div className="rs-services-number"></div>
                        <div className="rs-services-btn-wrapper">
                          <div className="rs-services-text-btn underline">
                            <Link className="rs-text-btn" to="#">
                              View Details
                            </Link>
                          </div>
                          <Link
                            className="rs-square-btn has-icon has-light-bg"
                            to="#"
                          >
                            <span className="icon-box">
                              <span className="icon-box">
                                <FaArrowRight className="icon-first" />
                                <FaArrowRight className="icon-second" />
                              </span>
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default BusinessPortfolio;
